import React from "react";
import {TextField} from "@mui/material";
import {forms, objects} from "@atttomyx/shared-utils";

const FileFilters = (props) => {
    const { data, onChange : onSync } = props;

    const onChange = (field, value) => {
        const modified = objects.deepCopy(data);
        modified[field] = value;

        onSync(modified);
    }

    return <div className="file-filters">
        <div className="field top-margin">
            <TextField
                label="Name"
                type="text"
                value={forms.sanitizeValue(data.fileName)}
                onChange={(event) => onChange("fileName", event.target.value)}
            />
        </div>
        <div className="field">
            <TextField
                label="Size"
                type="number"
                value={forms.sanitizeValue(data.size)}
                onChange={(event) => onChange("size", event.target.value)}
                inputProps={{
                    min: 0,
                }}
            />
        </div>
    </div>
}

export default FileFilters;
